var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameboy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 16.115H5.667c-2.586 0-4.073-1.488-4.073-4.073V4.959C1.594 2.373 3.08.886 5.667.886h5.666c2.586 0 4.073 1.487 4.073 4.073v7.083c0 2.585-1.487 4.073-4.073 4.073ZM5.667 1.948c-2.026 0-3.01.985-3.01 3.01v7.084c0 2.026.984 3.01 3.01 3.01h5.666c2.026 0 3.01-.984 3.01-3.01V4.959c0-2.026-.984-3.01-3.01-3.01H5.667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.51 8.323H5.49c-.978 0-1.771-.793-1.771-1.77V4.781c0-.978.793-1.771 1.77-1.771h6.021c.978 0 1.771.793 1.771 1.77v1.771c0 .978-.793 1.771-1.77 1.771Zm-6.02-4.25a.71.71 0 0 0-.709.709v1.77c0 .39.319.709.709.709h6.02a.71.71 0 0 0 .709-.709v-1.77a.71.71 0 0 0-.709-.709H5.49ZM5.667 12.984a.526.526 0 0 1-.376-.156.534.534 0 0 1 0-.75l1.63-1.63a.534.534 0 0 1 .75 0 .534.534 0 0 1 0 .75l-1.629 1.63a.526.526 0 0 1-.375.156Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.317 13.005a.526.526 0 0 1-.376-.155l-1.629-1.63a.534.534 0 0 1 0-.75.534.534 0 0 1 .751 0l1.63 1.629a.535.535 0 0 1 0 .75.526.526 0 0 1-.376.156ZM11.694 11.567a.717.717 0 0 1-.715-.708c0-.39.312-.709.701-.709h.014a.71.71 0 0 1 .709.709.71.71 0 0 1-.709.708ZM10.264 13.097a.704.704 0 0 1-.708-.702v-.014a.71.71 0 0 1 .708-.708.71.71 0 0 1 .708.708c0 .39-.319.716-.708.716Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameboy);
export default __webpack_public_path__ + "static/media/gameboy.88de5fa91c7c433ea74cb420771b5d8e.svg";
export { ForwardRef as ReactComponent };